
import React from "react";
import { Col, Row } from "react-bootstrap";

const HeaderBanner = () => {
  
  return (
    <>
      <header className="banner-header">
        <div >
          <div className="banner-header-row">

          <Row className="  h-100 align-items-center">
            <Col className="center-xy">
              <img src="/logo.webp" alt="" className="header-logo" loading="lazy"/>
            </Col>
            <Col>
              <p className="section-title fw-semibold mb-0 text-light">
                What do we do with all <br /> this
                <span className="fw-bold"> money?</span>
              </p>
            </Col>
            <Col className="center-xy">
              <img src="/images/dollar_note.png" alt="" className="w-25" loading="lazy"/>
            </Col>
          </Row>
          </div>
{/* <br /> */}
        </div>
      </header>

    </>
  );
};

export default HeaderBanner;
